import { Component, OnInit, ViewChild } from '@angular/core';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { Location } from '@angular/common';
import { ModuleDetailsModel } from 'app/module/models/module-details.model';
import { ModuleService } from 'app/module/services/module.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModuleQuestionBankListModel } from 'app/module/models/module-question-bank-list.model';

@Component({
    templateUrl: './module-details.component.html',
    styleUrls: ['./module-details.component.css']
})
export class ModuleDetailsComponent implements OnInit {
    moduleDetailsModel: ModuleDetailsModel;
    errors: string[];
    headerTitle: IHeaderTitle;
    submitAttempt = false;
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    redirectRoutes: Routes;
    moduleDetailsFormGroup: FormGroup;
    isEditMode: boolean = false;
    moduleId: string;
    selectedModuleId: string;
    moduleQuestionBanks: ModuleQuestionBankListModel[];

    constructor(
        private moduleService: ModuleService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
		private location: Location,
        private router: Router,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.moduleId = this.activatedRoute.snapshot.params['id'];
        this.moduleService.get(this.moduleId).subscribe(moduleInfo => {
            this.moduleDetailsModel = moduleInfo;
            this.initializeForm(moduleInfo);
            this.headerTitle = {
                title: moduleInfo.name,
                breadcrumbs: [{ title: 'Modules', url: ['/module'] }]
            };
            this.moduleService.getModuleQuestionBanks(this.moduleId).subscribe(
                moduleQuestionBanks => {
                    this.moduleQuestionBanks = moduleQuestionBanks;
                },
                error => this.errors = error.errorList
            );
        });
    }

    initializeForm(model: ModuleDetailsModel): void {
        this.moduleDetailsFormGroup = this.fb.group(
            {
                id: [this.moduleId],
                name: [model.name, Validators.required],
                isActive: [model.isActive, Validators.required]
            }
        );
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    updateModule(): void {
        this.submitAttempt = true;
        if (this.moduleDetailsFormGroup.valid) {
            const formValue = this.moduleDetailsFormGroup.value;
            this.moduleService.update(formValue).subscribe(
                response => {
                    this.alertMessage.showMessage();
                },
                error => {
                    this.errors = error.errorList;
                }
            );
        }
    }

    successClicked($event: any): void {
        this.router.navigate(['./module']);
    }

    onHide($event: any): void { }

    onBack($event: any): void {
        this.location.back();
    }

    deleteModule() {
        this.moduleService.deleteModule(this.selectedModuleId).subscribe(
            result => this.location.back(),
            error => console.log(error)
        );
    }

    openCannotDeleteModule(content) {
        this.modalService.open(content);
    }

    questionBanksUpdated() {
        this.load();
    }
}
